import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { selectCallData } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import { selectTextFrom911Conversation } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Slice';

/**
 * Custom selector that returns data for a given phone number using multiple
 * data sources.
 * Intended for the purposes of displaying indicators in the call queue UI.
 * Note: if another data source is needed, such as ADR or Video To 911, add
 * another selector function and update createSelector below
 * @param {String} callerID - phone number
 */
const numberFullDataSelector = createSelector(
  selectCallData,
  selectTextFrom911Conversation,
  (callData, textFrom911Data) => {
    return {
      callData,
      textFrom911Data,
    };
  },
);

const useFullSelectedNumberData = callerID => {
  const fullSelectedNumberData = useSelector(state =>
    numberFullDataSelector(state, callerID),
  );
  return fullSelectedNumberData;
};

export default useFullSelectedNumberData;
